import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import TokenService from "~/common/service.token";
import { API_URL } from "~/config";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        localStorage.setItem("app_url", API_URL)
        this.setHeader();
    },

    setHeader() {
        Vue.axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${TokenService.getToken()}`;
    },

    removeHeader() {
        delete Vue.axios.defaults.headers.common["Authorization"];
    },

    query(resource, params) {
        return Vue.axios.get(resource, params).catch(error => {
            throw new Error(`[Nissho] ApiService ${error}`);
        });
    },

    get(resource, slug = "") {
        let url = "";
        if (slug === "") {
            url = resource;
        } else {
            url = `${resource}/${slug}`;
        }
        return Vue.axios.get(url).catch(error => {
            throw new Error(`[Nissho] ApiService ${error}`);
        });
    },

    query_params_string(resource, params) {
        return Vue.axios
            .get(`${resource}?${new URLSearchParams(params).toString()}`)
            .catch(error => {
                throw new Error(`[Nissho] ApiService ${error}`);
            });
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params);
    },

    update(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params);
    },

    delete(resource, params) {
        return Vue.axios
            .delete(`${resource}`, { params: params })
            .catch(error => {
                throw new Error(`[Nissho] ApiService ${error}`);
            });
    }
};

export default ApiService;

const CLEANING_OFFICES_URI = "cleaning_offices";

export const CleaningOfficesService = {
    query(params) {
        return ApiService.query(CLEANING_OFFICES_URI, params);
    },
    get(slug) {
        return ApiService.get(CLEANING_OFFICES_URI, slug);
    },
    create(params) {
        return ApiService.post(CLEANING_OFFICES_URI, params);
    },
    update(slug, params) {
        return ApiService.update(CLEANING_OFFICES_URI, slug, {
            cleaning_office: params
        });
    },
    destroy(slug) {
        return ApiService.delete(`${CLEANING_OFFICES_URI}/${slug}`);
    }
};
export const AuthService = {
    post(resource, params) {
        delete Vue.axios.defaults.headers.common["Authorization"];
        return Vue.axios.post(`${resource}`, params);
    }
};

export const WithdrawService = {
    query_params_string(uri,params){
        return ApiService.query_params_string(uri, params);
    },
    get(param){
        return ApiService.get(param);
    },
    post(uri, params){
        return ApiService.post(uri, params);
    },
};

export const ReferralService = {
    get_list_banner(){
        let resource = 'customer/list-banner';
        return ApiService.get(resource);
    },
    get_list_presenter(){
        let resource = 'list-presenter';
        return ApiService.get(resource);
    },
    get_percent_presenter(){
        let resource = 'get-percent-presenter';
        return ApiService.get(resource);
    }
};